import React from 'react'
import { getGreeting } from '@verzekeringapp-mono/shared/src/utils/greeting'

const UserInfo: React.FC<{ firstName: string }> = ({ firstName }) => (
  <div className='col-span-2'>
    <p className='text-2xl font-light light'>{getGreeting()},</p>

    <p className='text-3xl font-semibold'>{firstName}</p>

    <p className='mt-4 hidden leading-loose text-text-primary md:block'>
      Welkom in je omgeving. Hierin vind je een overzicht van je
      polis/verzekeringen, kun je gemakkelijk en snel schade melden, een
      schadehersteller vinden, contact opnemen met de adviseur en zijn er ook
      nog leuke ledenvoordelen.
    </p>
  </div>
)

export default UserInfo
